<template>
  <div class="project-app">
    <My-new-nav ref="header" menuTheme="dark"></My-new-nav>
    <div class="solution-cont">
      <div class="banner-title">数字化运营解决方案</div>
      <div class="banner-message">数字化时代，与医智诺一起重新定义业务关系</div>
    </div>
    <div class="card" style="background-color: #F9F9FD;">
      <ecn-title title="打造医疗企业数字化运营业务场景"></ecn-title>
      <div class="solution-scene">
        <img src="../../../assets/image/Mobile/solution/opera_card1.png" alt="">
      </div>
    </div>
    <div class="card">
      <ecn-title title="O2O数字化运营服务"></ecn-title>
      <div class="solution-channel">
        <div class="channel-lf-title">主动出击 构建患者流量池</div>
        <ul>
          <li> <span></span>线上线下引流渠道</li>
          <li><span></span>占据终端场景</li>
          <li><span></span>专属平台工具</li>
          <li><span></span>专属运营团队</li>
          <li><span></span>定制医生品牌推广方案</li>
          <li><span></span>合法合规 阳光收益</li>
        </ul>
      </div>
      <div class="solution-channel-rg">
        <img src="../../../assets/image/Mobile/solution/opera_card3.png" alt="">
      </div>
    </div>
    <div class="card" style="background-color: #F9F9FD;">
      <ecn-title title="市场推广服务"></ecn-title>
      <div class="ecn-slide">
        <carousel-3d :perspective="0" :border="0" :display="3" :width="530" :height='723' :inverseScaling="-30"
          :space="600" :startIndex="1">
          <slide v-for="(item, i) in marketList" :index="i" :key="i">
            <div class="slideItem">
              <img :src="item.img" alt="" />
              <dl class="textList">
                <dt>{{ item.title }}</dt>
                <dd v-for="str in item.desc" :key='str'>{{ str }}</dd>
              </dl>
              <div class="mask"></div>
            </div>
          </slide>
        </carousel-3d>
      </div>
    </div>
    <div class="card" style="background-color: #F9F9FD;">
      <div class="fourWrap">
        <ecn-title title="临床科研服务"></ecn-title>
        <div class="desc left">
          <span class="lf-circle"></span>
          <div>
            <div class="text">01</div>
            <b class="text">真实世界研究(RCT/RWR…)</b>
            <p>研究中心筛选、机构立项、伦理审查协助、研究系统开发与维护、真实世界证据</p>
          </div>
        </div>
        <div class="desc right">
          <span class="rh-circle"></span>
          <div>
            <div class="text">02</div>
            <b class="text">药物临床试验</b>
            <p>招募进程可视化管理、招募信息发布、科研项目管理、科研数据管理、分析</p>
          </div>
        </div>
        <div class="blank"></div>
        <div class="desc left">
          <span class="lf-circle"></span>
          <div>
            <div class="text">03</div>
            <b class="text">药物经济学评价</b>
            <p>药物研发决策、降低研发成本、控制药物费用、协助药品品规、剂型迭代、协助医疗保险药品目录、协助开展药物指南制订</p>
          </div>
        </div>
        <div class="desc right">
          <span class="rh-circle"></span>
          <div>
            <div class="text">04</div>
            <b class="text">药物临床路径</b>
            <p>产品临床后研究、产品学术信息推广、产品学术地位、调整产品结构化、助力医保、商保目录建立、助力医疗指南、专家共识
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import img1 from '../../../assets/image/solution/solution-market1.png';
import img2 from '../../../assets/image/solution/solution-market2.png';
import img3 from '../../../assets/image/solution/solution-market3.png';
export default {
  data() {
    return {
      marketList: [
        {
          title: '医智诺平台广告',
          img: img1,
          desc: [
            '核心广告合作',
            '品牌商业合作',
          ]
        },
        {
          title: '医疗会议系统',
          img: img2,
          desc: [
            '大型学术会议',
            '线上科室会',
            '新药发布会',
            'MDT会议',
            'AB专家会',
            '专家讲座',
            '学术年会',
          ]
        },
        {
          title: '医生大IP打造',
          img: img3,
          desc: [
            '多平台IP账号建设',
            '医疗科普短视频、科普直播',
            '内容、文章、视频制作及发布',
          ]
        },
      ]
    }
  }
}
</script>
<style scoped lang="scss">
.project-app {

  .solution-cont {
    background-image: url('../../../assets/image/Mobile/solution/operation_bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 53vw;
    padding-left: 54px;

    .banner-title {
      font-size: 72px;
      line-height: 93px;
      letter-spacing: 8px;
      color: #FFFFFF;
      font-family: YouSheBiaoTiHei;
      text-shadow: 0px 0px 6px rgba(6, 58, 148, 0.5);
      padding-top: 21vw;
    }

    .banner-message {
      font-size: 30px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      color: #FFFFFF;
      line-height: 36px;
      letter-spacing: 12px;
      text-shadow: 0px 0px 6px rgba(6, 58, 148, 0.5);
      margin-top: 20px;
    }
  }

  .card {
    padding-top: 120px;
    overflow: hidden;
  }

  .solution-scene {
    width: 96%;
    margin: 96px auto 120px;

    img {
      width: 100%;
      display: block;
      margin: auto;
    }
  }

  .solution-channel {
    height: 516px;
    margin-top: 96px;
    background-image: url(../../../assets/image/Mobile/solution/opera_card2.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding-left: 90px;

    .channel-lf-title {
      font-size: 38px;
      font-weight: Bold;
      letter-spacing: 6px;
      color: #fff;
      padding-top: 60px;
    }

    ul {
      color: #fff;
      margin-top: 16px;

      li {
        font-size: 34px;
        font-weight: 400;
        letter-spacing: 3px;
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        span {
          display: block;
          width: 10px;
          height: 10px;
          margin-right: 18px;
          background-color: #fff;
          border-radius: 50%;
        }
      }
    }
  }

  .solution-channel-rg {
    padding: 60px 36px 120px;

    img {
      width: 100%;
      display: block;
    }
  }

  .ecn-slide {
    margin-top: 64px;

    .slideItem {
      position: relative;

      .mask{
        transition-property: opacity;
        transition-duration: .5s;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: linear-gradient(180deg, rgba(37,125,254,0.7) 0%, #257DFE 100%);
        opacity: 0;
      }
      .textList {
        position: absolute;
        left: 32px;
        bottom: 32px;
        z-index: 1;

        dt {
          font-size: 40px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 62px;
        }

        dd {
          transition-property: opacity,height;
          transition-duration: .5s;
          font-size: 32px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 44px;
          height: 0;
          opacity: 0;
        }
      }
    }

    .current .slideItem {
      .mask{
        opacity: 0.5;
      }
      .textList {
        dd {
          height: 44px;
          opacity: 1;
        }
      }
    }
  }

  .fourWrap {
    padding-bottom: 120px;
    background: url(../../../assets/image/Mobile/solution/opera_card4.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position-x: center;
    background-position-y: 706px;

    .blank {
      height: 68vw;
    }

    .desc {
      width: 76vw;
      margin: 30px auto 0;
      position: relative;

      &.left {
        margin-left: 8vw;
      }

      &.right {
        margin-right: 8vw;

        .text {
          text-align: right;
        }
      }

      &>span {
        display: block;
        position: absolute;
        width: 80px;
        height: 80px;
        background-color: #fff;
        border-radius: 50%;
        position: absolute;
        top: 16px;
        box-shadow: 0 0 11px rgba(10, 79, 226, 0.1300);
      }

      div {
        position: relative;
        color: #0D6EFD;

        div {
          font-size: 46px;
          font-weight: bold;
          letter-spacing: 3.68px;
        }

        b {
          font-size: 38px;
          display: block;
          width: 100%;
          letter-spacing: 3px;
        }

        p {
          margin-top: 16px;
          font-size: 32px;
          color: #333333;
          font-weight: normal;
          letter-spacing: 5px;
          line-height: 54px;
          text-align: justify;
        }
      }

      .lf-circle {
        left: -25px;
      }

      .rh-circle {
        right: -29px;
      }
    }
  }



  .ecn-title ::v-deep {
    padding-left: 54px;

    .title {
      font-size: 54px;
      line-height: 54px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      color: #333;
      letter-spacing: 3px;
    }

    .line {
      width: 84px;
      height: 18px;
      margin-top: 24px;
    }
  }
}</style>